import { render, staticRenderFns } from "./ycd-payment-middle.vue?vue&type=template&id=6ff7b780&scoped=true&"
import script from "./ycd-payment-middle.vue?vue&type=script&lang=ts&"
export * from "./ycd-payment-middle.vue?vue&type=script&lang=ts&"
import style0 from "./ycd-payment-middle.vue?vue&type=style&index=0&id=6ff7b780&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff7b780",
  null
  
)

export default component.exports